class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
		this.classList.remove('open');
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerMain = this.closest('.header');
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.toggleClass.bind(this));

    if (this.dataset.menuHover === 'true') this.initHover();
  }

	toggleClass() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.header.classList.add('open');
      this.headerMain.classList.add('open');
      this.mainDetailsToggle.classList.add('open');
    } else {
      this.header.classList.remove('open');
      this.headerMain.classList.remove('open');
      this.mainDetailsToggle.classList.remove('open')
    }
	}

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  /* Hover behaviour (desktop pointer devices only). Mouse enter opens the
     menu after a short delay so sweeping across the bar doesn't flicker;
     mouse leave closes it after a grace period so the pointer can travel
     from the label down into the panel. Click still works (touch/keyboard);
     the top-level label itself never navigates. */
  initHover() {
    this.hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
    this.summary = this.mainDetailsToggle.querySelector('summary');

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onMouseEnter() {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.closeTimer);
    if (this.mainDetailsToggle.open) return;

    this.openTimer = setTimeout(() => {
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this && menu.mainDetailsToggle && menu.mainDetailsToggle.open) menu.close();
      });
      this.mainDetailsToggle.open = true;
      this.summary.setAttribute('aria-expanded', 'true');
    }, 90);
  }

  onMouseLeave() {
    if (!this.hoverQuery.matches) return;
    clearTimeout(this.openTimer);
    this.closeTimer = setTimeout(() => this.close(), 220);
  }

  onSummaryClick(event) {
    // In hover mode the top-level label is not a link and never navigates:
    // clicking an already-open menu keeps it open; clicking a closed one
    // (e.g. keyboard or touch) toggles it natively.
    if (!this.hoverQuery.matches) return;
    if (this.mainDetailsToggle.open) event.preventDefault();
  }
}

customElements.define('header-menu', HeaderMenu);